export function areStringArraysEqual(firstArray: Array<string>, secondArray: Array<string>) {
    return firstArray.length === secondArray.length && firstArray.every((val) => secondArray?.includes(val));
}
